import { action, computed, observable, runInAction, makeObservable } from 'mobx';
import authStore from './authStore';
import routing from './routingStore';
import viewStore from './viewStore';
import Http from '../Http';
import Storage from '../Storage';
import utils, { parseError } from '../utils';

class ReceiptStore {
  @observable skeleton;
  @observable currentReceiptId;
  @observable receipts = new Map();

  @observable loadingReceipts = new Map();

  // last sync times
  receiptsSynced = {};

  canGoBack = false;


  constructor() {
    makeObservable(this);
    const receipts = Storage.get('receipts');

    if (receipts) {
      this.receipts.replace(receipts);
    }
  }

  @computed
  get cacheId() {
    return authStore.companyToken + '.' + this.currentReceiptId;
  }

  @computed
  get isLoading() {
    return this.loadingReceipts.has(this.currentReceiptId);
  }

  @computed
  get receipt() {
    return this.receipts.get(this.cacheId) || this.skeleton || {};
  }

  @action.bound
  clear() {
    this.skeleton = null;
    this.currentReceiptId = null;
    this.receiptsSynced = {};
    this.receipts.clear();
  }

  @action.bound
  async fetch() {
    const receiptId = this.currentReceiptId;

    if (this.receipts.has(this.cacheId) && this.receiptsSynced[receiptId] && this.receiptsSynced[receiptId] > Date.now() - utils.CACHE_TIME) {
      return;
    }

    this.loadingReceipts.set(receiptId, true);

    await this.update();

    runInAction(() => {
      this.loadingReceipts.delete(receiptId);
    });
  }

  @action.bound
  async refresh() {
    const receiptId = this.currentReceiptId;

    if (this.loadingReceipts.has(receiptId)) {
      return;
    }

    this.loadingReceipts.set(receiptId, true);

    await this.update();

    runInAction(() => {
      this.loadingReceipts.delete(receiptId);
    });
  }

  @action.bound
  async update() {
    const receiptId = this.currentReceiptId;
    const cacheId = this.cacheId;

    try {
      const receipt = await Http.crequest('kuitit/' + receiptId);

      runInAction(() => {
        this.receipts.set(cacheId, receipt);
      });

      Storage.set('receipts', this.receipts);

      this.receiptsSynced[receiptId] = Date.now();
    } catch (error) {
      viewStore.showSnackbar(parseError(error));
    }
  }

  @action.bound
  hideReceipt() {
    this.currentReceiptId = null;

    if (this.canGoBack) {
      routing.goBack();
    } else {
      routing.push('/tulos');
    }
  }

  @action.bound
  setCurrent(id) {
    this.currentReceiptId = id;
    this.fetch();
  }
  // When drilling deep enought this function shows the actual receipt.
  @action.bound
  showReceipt(receipt, category) {

    //this.saveScroll();

    receipt.tositelaji = { SELITE: category.name };

    this.skeleton = receipt;

    this.canGoBack = true;

    routing.push(`/tositteet/${receipt.TOSITEID}`);
  }
}

export default new ReceiptStore();
